<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'integraciones' }">{{
                $t("integraciones")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("GStock") }}
            </li>
          </ol>
        </nav>
      </div>
      <CabeceraInformes :idBusiness="idBusiness" :listBusinesses="listBusinesses" :idTpv="this.idTpv" :listTpv="listTpv"
        :dateto="dateto" :datefrom="datefrom" id="cabecera" :conTodos="true" :gStock="true" />
      <template v-if="configTpv">
        <vue-tabs @tab-change="handleTabChange" v-model="tabs" class="col-md-12">
          <!-- NO quitar, si se quita no funciona -->
          <v-tab title="" :disabled="true"></v-tab>
          <v-tab title="Productos">
            <div class="row">
              <el-select style="margin: 20px" class="select-default col-md-2" size="large" v-model="idCategoria"
                filterable @change="getProductos()" :placeholder="'Todos'">
                <el-option class="select-primary" :value="0" :label="'Todos las Categorías'">
                </el-option>
                <el-option v-for="c in listCategorias" class="select-primary" :value="c.id" :label="c.name" :key="c.id">
                </el-option>
              </el-select>
              <div class="col-md-3 text-right">
                <div class="input-group" style="margin: 20px">
                  <input type="text" class="form-control" v-bind:placeholder="$t('buscar')" v-model="searchQuery2"
                    @keyup.enter.prevent="searchProductos" />
                  <div class="input-group-append">
                    <button class="btn btn-secondary" type="button" @click="searchProductos">
                      <i class="fa fa-search"></i>
                    </button>
                    <button class="btn btn-secondary" type="button" @click="removeSearchProduct">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-for="(p, indice) in list">
              <h5 class="wrapperNegocio">{{ p.nameCat }}</h5>
              <div class="table-responsive">
                <table class="table table-bordered table-striped text-nowrap">
                  <thead class="thead-dark">
                    <tr style="cursor: pointer">
                      <th><i style="color: white"></i> {{ $t("nombre") }}</th>
                      <th><i style="color: white"></i> {{ $t("precio") }}</th>
                      <th><i style="color: white"></i>PLU</th>
                      <th><i style="color: white"></i> {{ $t("acciones") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(obj, index) in p.listProducts">
                      <td v-if="obj.nameprice.trim() !== ''">{{ obj.name.trim() + " [" + obj.nameprice.trim() + "]" }}
                      </td>
                      <td v-else>{{ obj.name.trim() }}</td>

                      <td>{{ obj.price | currency }}</td>
                      <td width="20%">
                        <input class="form-control" type="text" v-model="obj.newPLU" />
                      </td>
                      <td align="center">
                        <button v-if="obj.PLU == obj.newPLU" class="btn btn-primary">
                          <i class="fa-solid fa-floppy-disk"></i>
                        </button>
                        <button v-else class="btn btn-warning" @click="changedPLU(obj, 0)">
                          <i class="fa-solid fa-floppy-disk"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="row" v-if="totalPags > 1">
              <div class="col-md-12">
                <nav>
                  <ul class="pagination flex-wrap">
                    <li class="page-item" :class="{ gstock: pag == 1 }">
                      <router-link class="page-link" :to="{ name: 'gstock', params: { pag: pag - 1 } }"
                        v-if="pag != 1">&laquo;
                      </router-link>
                      <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                    </li>
                    <li class="page-item" v-for="n in totalPags" :class="{ active: n == pag }">
                      <router-link class="page-link" :to="{ name: 'gstock', params: { pag: n } }">
                        {{ n }}
                      </router-link>
                    </li>
                    <li class="page-item" :class="{ disabled: pag == totalPags }">
                      <router-link class="page-link" :to="{ name: 'gstock', params: { pag: nextPag } }"
                        v-if="pag != totalPags">
                        &raquo;
                      </router-link>
                      <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </v-tab>
          <v-tab title="Materias Primas">
            <div class="row">
              <el-select style="margin: 20px" class="select-default col-md-2" size="large" v-model="idTag" filterable
                remote @change="getSubproducts()" :placeholder="'Todos'">
                <el-option class="select-primary" :value="0" :label="'Todos las Categorías'">
                </el-option>
                <el-option v-for="c in listTags" class="select-primary" :value="c.id" :label="c.name" :key="c.id">
                </el-option>
              </el-select>
              <div class="col-md-3 text-right">
                <div class="input-group" style="margin: 20px">
                  <input type="text" class="form-control" v-bind:placeholder="$t('buscar')" v-model="searchQuery"
                    @keyup.enter.prevent="searchSubproductos" />
                  <div class="input-group-append">
                    <button class="btn btn-secondary" type="button" @click="searchSubproductos">
                      <i class="fa fa-search"></i>
                    </button>
                    <button class="btn btn-secondary" type="button" @click="removeSearchSubPRoduct">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-for="(p, indice) in listSubproducts">
              <h5 class="wrapperNegocio">{{ p.nameTag }}</h5>
              <div class="table-responsive">
                <table class="table table-bordered table-striped text-nowrap">
                  <thead class="thead-dark">
                    <tr style="cursor: pointer">
                      <th><i style="color: white"></i> {{ $t("nombre") }}</th>
                      <th><i style="color: white"></i>PLU</th>
                      <th><i style="color: white"></i> {{ $t("acciones") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(obj, index) in p.listSubProducts">
                      <td>{{ obj.name.trim() }}</td>
                      <td width="20%">
                        <input class="form-control" type="text" v-model="obj.newPLU" />
                      </td>
                      <td align="center">
                        <button v-if="obj.PLU == obj.newPLU" class="btn btn-primary">
                          <i class="fa-solid fa-floppy-disk"></i>
                        </button>
                        <button v-else class="btn btn-warning" @click="changedPLU(obj, 1)">
                          <i class="fa-solid fa-floppy-disk"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row" v-if="totalPags > 1">
              <div class="col-md-12">
                <nav>
                  <ul class="pagination flex-wrap">
                    <li class="page-item" :class="{ gstock: pag == 1 }">
                      <router-link class="page-link" :to="{ name: 'gstock', params: { pag: pag - 1 } }"
                        v-if="pag != 1">&laquo;
                      </router-link>
                      <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                    </li>
                    <li class="page-item" v-for="n in totalPags" :class="{ active: n == pag }">
                      <router-link class="page-link" :to="{ name: 'gstock', params: { pag: n } }">
                        {{ n }}
                      </router-link>
                    </li>
                    <li class="page-item" :class="{ disabled: pag == totalPags }">
                      <router-link class="page-link" :to="{ name: 'gstock', params: { pag: nextPag } }"
                        v-if="pag != totalPags">
                        &raquo;
                      </router-link>
                      <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </v-tab>
        </vue-tabs>
      </template>
      <template v-else>
        <div class="col-md-12">
          <div class=" alert alert-primary" align="center">
            <h3>
              <i class="fas fa-exclamation-circle"></i>
              {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
            </h3>

            <span>
              {{ $t("paraMasInformacionContacteConSu") }}
              <strong>{{ $t("distribuidor") }}</strong>.</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading,
} from "element-ui";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import swal from "sweetalert2";
import moment from "moment";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("GStock"));
    this.tabs = "Productos"
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }

    this.loading.close();
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      idBusiness: 0,
      list: [],
      mode: 0,
      objectChart: null,
      contador: 0,
      listTpv: [],
      idTpv: -1,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },

      ordenacionOperario: 0,
      ordenarImporte: 0,
      ordenarInvitations: 0,
      ordenarDifHora: 0,
      ordenarSueldo: 0,
      ordenarEfectivo: 0,
      ordenarTarjeta: 0,
      ordenarCheque: 0,
      ordenarIssues: 0,
      idTpvAMandar: " ",
      configTpv: false,
      respuesta: true,
      indice: 0,
      totalPags: 0,
      pag: this.$route.params.pag,
      cambiar: 0,
      objindex: -1,
      idCategoria: 0,
      listCategorias: [],
      idTag: 0,
      listSubproducts: [],
      tabs: "",
      listTags: [],
      searchQuery: "",
      searchQuery2: "",
      config98: false,
      config99: false,
      config101: false,
      loadingGeneral: null,
    };
  },
  computed: {
    nextPag() {
      let nextPag = parseInt(this.pag) + 1;
      return nextPag;
    },
    nextPagSub() {
      let nextPag = parseInt(this.pagSub) + 1;
      return nextPag;
    },
  },
  watch: {
    $route(to, from) {
      if (to.params.pag) {
        this.pag = to.params.pag;
        if (this.tabs == "Productos") {
          this.getProductos();
        } else if (this.tabs == "Materias Primas") {
          this.getSubproducts();
        }
      } else if (to.params.query) {
        this.query = to.params.query;
        if (this.tabs == "Productos") {

          this.getProductos();
        } else if (this.tabs == "Materias Primas") {
          this.getSubproducts();
        }
      }
    },
  },
  methods: {
    cambioBusiness(idBusinessData, listTpv) {
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.list = [];
      this.pag = 1;
      this.totalPags = 0;

      this.cambioTpv(this.idTpv);
      this.getConfigGStock();
      // this.getConfigTpv(98);



      if (this.tabs == "Materias Primas") {

        this.getSubproducts();
      } else if (this.tabs == "Productos") {

        //this.handleTabChange();
        this.getProductos();
      }

      this.loadingGeneral.close();
    },

    emitirConsulta() {
      //this.loading = Loading.service({ text: "Cargando..." });
      //this.getSalesOperarios();
      //this.exportGStock();

      this.ConfirmacionExport();
    },

    cambioTpv(idTpvData, filtrar) {
      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
      }

      this.idTpv = idTpvData;

      //this.emitirConsulta();
    },

    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }
          vm.getConfigTpv(98);

          vm.getTpv();

          vm.getProductos();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            vm.listCheckBoxTpv = response.data.result;

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);
            }

            // vm.exportGStock();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigGStock() {
      let vm = this;

      let configIdentificador = 98;

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          numConfig: configIdentificador,
        },

        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/checkConfigByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.configTpv = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    exportGStock() {
      this.loading = Loading.service({ text: "Cargando..." });
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        this.loading.close();
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

          this.loading.close();
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          if (this.idTpv == -1) {
            this.idTpvAMandar = 0;
          } else {
            this.idTpvAMandar = this.idTpv;
          }

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idTpv: 0,
              datefrom: moment(this.datefrom).startOf("day").unix(),
              dateto: moment(this.dateto).endOf("day").unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          var params = {
            idBusiness: this.idBusiness,
            idTpv: 0,
            datefrom: moment(this.datefrom).startOf("day").unix(),
            dateto: moment(this.dateto).endOf("day").unix(),
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .post(
              this.$store.getters.apiUrl + "integracion/gstock/exportarGStock",
              params,
              config
            )
            .then(function (response) {
              console.log("RESPUESTA");
              console.log(response.data);
              vm.loading.close();
              // if (response.data.result == null) {
              //   swal({
              //     title: vm.$t("ventasExportadasExsitosamente"),
              //     confirmButtonClass: "btn btn-info btn-fill",
              //     type: "success",
              //   });
              //   vm.respuesta = true;
              // } else if (response.data.result != null) {

              //   swal({
              //     title: "Lo sentimos",
              //     text: response.data.result,
              //     confirmButtonClass: "btn btn-info btn-fill",
              //     type: "info",
              //   });
              //   vm.respuesta = false;
              // } else if (response.data.response == false) {
              //   swal({
              //     title: "Lo sentimos",
              //     text: response.data.result,
              //     confirmButtonClass: "btn btn-info btn-fill",
              //     type: "info",
              //   });
              //   vm.respuesta = false;
              // } else {
              //   swal({
              //     title: vm.$t("accesoDenegado"),
              //     text: "error",
              //     confirmButtonClass: "btn btn-info btn-fill",
              //     type: "error",
              //   });

              //   vm.respuesta = false;
              // }
              if (response.status === 200) {
                if (response.data.result == null) {
                  swal({
                    title: vm.$t("ventasExportadasExsitosamente"),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "success",
                  });
                  vm.respuesta = true;
                } else {
                  swal({
                    title: "Lo sentimos",
                    text: response.data.result,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "info",
                  });
                  vm.respuesta = false;
                }
              } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: "error",
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function (error) {
              vm.loading.close();

              if (error.response) {
                // El servidor respondió con un código de estado fuera del rango de 2xx
                console.log("Error Response", error.response.data);
                console.log("Error Status", error.response.status);
                console.log("Error Headers", error.response.headers);

                if (error.response.status === 400) {
                  swal({
                    title: "Error 400",
                    text: (error.response.data.message),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                } else if (error.response.status === 401) {
                  swal({
                    title: "Error 401",
                    text: (error.response.data.message),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                } else {
                  swal({
                    title: "Error",
                    text: `Código de error: ${error.response.status}`,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                }
              } else if (error.request) {
                // La solicitud se hizo pero no se recibió respuesta
                console.log("Error Request", error.request);
                swal({
                  title: "Error",
                  text: "No se recibió respuesta del servidor.",
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              } else {
                // Algo pasó al configurar la solicitud que desencadenó un error
                console.log("Error Message", error.message);
                swal({
                  title: "Error",
                  text: `Error en la configuración de la solicitud: ${error.message}`,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
            });
        }
      }
    },
    getConfigTpv(numConfig) {

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: numConfig,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkConfigByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            if (numConfig == 98) {
              vm.config98 = response.data.result
            } else if (numConfig == 99) {
              vm.config99 = response.data.result
            } else if (numConfig == 101) {
              vm.config101 = response.data.result
            }
          } else {

          }
        })
        .catch(function (error) {
          console.log(error);
        });

    },
    ConfirmacionExport() {
      if (!this.configTpv) {
        swal({
          type: "error",
          title: "No tienes permisos para exportar los datos a Gstock",
          //text: 'Something went wrong!',
        });
      } else {
        swal({
          title: this.$t("estasSeguroDeExportarLasVentas"),
          text:
            this.$t("ventasExportadas") +
            " (" +
            moment(String(this.datefrom)).format("DD/MM/YYYY") +
            " " +
            moment(String(this.dateto)).format("DD/MM/YYYY") +
            ")",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-info btn-fill",
          cancelButtonClass: "btn btn-info btn-fill",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCloseButton: true,
        }).then((result) => {
          if (result.value) {
            this.exportGStock();
          }
        });
      }
    },

    getProductos() {
      //this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      const controller = this.searchQuery2
        ? "gstock/searchProductsByBusiness/" + this.searchQuery2
        : "gstock/getProductsGstock";

      var config = {
        params: {
          idBusiness: this.idBusiness,
          idTpv: 0,
          pag: this.pag,
          idCategoria: this.idCategoria,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "integracion/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.list = response.data.result.elementos;
            vm.pag = response.data.result.pag;
            vm.totalPags = response.data.result.totalPags;
            //   console.log(vm.totalPags);
            vm.getCategorias();
          } else {
            vm.loadingGeneral.close();
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
          //console.log(vm.list);
          //vm.loadingGeneral.close();
        })
        .catch(function (error) {
          console.log(error);
        });

    },
    changedPLU(obj, tipo) {
      if (tipo == 0) {
        var config = {
          params: {
            idBusiness: this.idBusiness,
            idProduct: obj.id,
            newPLU: obj.newPLU,
            tipo: tipo,
            rate: obj.rate,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

      } else {
        var config = {
          params: {
            idBusiness: this.idBusiness,
            idProduct: obj.id,
            newPLU: obj.newPLU,
            tipo: tipo,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

      }

      var params = {
        idBusiness: this.idBusiness,
        idProduct: obj.id,
        newPLU: obj.newPLU,
        tipo: tipo,
        jwt: this.$store.getters.jwt,
      };
      console.log(params);
      let vm = this;
      let controller = "gstock/updatePLU";
      this.axios
        .post(
          this.$store.getters.apiUrl + "integracion/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            let notify = vm.$t("actualizado");
            vm.$notify({
              message:
                vm.$t("coste") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
            obj.PLU = obj.newPLU;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getCategorias() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "integracion/gstock/getCategorias",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCategorias = response.data.result;
            //   console.log(vm.totalPags);

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }

          vm.loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getSubproducts() {
      const controller = this.searchQuery
        ? "gstock/searchSubproductsByBusiness/" + this.searchQuery
        : "gstock/getSubproductsByBusinessGStock";
      var config = {
        params: {
          pag: this.pag,
          idBusiness: this.idBusiness,
          idTag: this.idTag,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "integracion/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listSubproducts = response.data.result.elementos;
            vm.pag = response.data.result.pag;
            vm.totalPags = response.data.result.totalPags;

            vm.respuesta = true;

            vm.getTags();
          } else {
            vm.loadingGeneral.close();
            swal({
              title: this.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTags() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "subproducts/getTagsByBusiness",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listTags = response.data.result;
            //   console.log(vm.totalPags);
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }

          vm.loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    handleTabChange(tabIndex, newTab, oldTab) {
      this.pag = 1;
      this.searchQuery = "";
      this.n = 0;
      // console.log(newTab)
      if (this.tabs == "Materias Primas") {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        this.getSubproducts();
        this.loadingGeneral.close();
      } else if (this.tabs == "Productos") {
        // this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

        this.getProductos();
      }


    },

    searchSubproductos() {
      if (this.searchQuery !== undefined && this.searchQuery !== "") {
        this.$router.push({
          name: "search-prducto-gs",
          params: { query: this.searchQuery },
        });
        //this.isSearch = true;
      }
    },
    removeSearchSubPRoduct() {
      if (this.searchQuery && this.searchQuery !== "") {
        this.searchQuery = "";
        //  this.isSearch = false;
        this.$router.push({ name: "gstock", params: { pag: 1 } });
        this.getSubproducts();
      }
    },
    searchProductos() {

      if (this.searchQuery2 !== undefined && this.searchQuery2 !== "") {
        console.log(this.searchQuery2)
        this.$router.push({
          name: "search-prducto-gs",
          params: { query: this.searchQuery2 },
        });
        //  this.isSearch = true;
      }
    },
    removeSearchProduct() {
      if (this.searchQuery2 && this.searchQuery2 !== "") {
        this.searchQuery2 = "";
        //this.isSearch = false;
        this.$router.push({ name: "gstock", params: { pag: 1 } });
        this.getProductos();
      }
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/G-Stock/G-Stock.vue